import { render, staticRenderFns } from "./PlanillaRedireccionamientoFirmas.vue?vue&type=template&id=0812f81c"
import script from "./PlanillaRedireccionamientoFirmas.vue?vue&type=script&lang=js"
export * from "./PlanillaRedireccionamientoFirmas.vue?vue&type=script&lang=js"
import style0 from "./PlanillaRedireccionamientoFirmas.vue?vue&type=style&index=0&id=0812f81c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports